import TOOL_COMPONENTS from '../constants/toolComponents';
import { TOOL_TYPE_PREFIX } from '../constants/toolParts';

import type { ComponentType } from 'react';
import type IAiChatMessagePart from 'store/slices/aiChats/interfaces/IAiChatMessagePart';
import type IAiChatToolCall from '../interfaces/IAiChatToolCall';

/** What a custom tool component is handed: the part, as the row holds it. */
type TToolComponent = ComponentType<Pick<IAiChatToolCall, 'part'>>;

/**
 * Component of the tool called `name`, ready to take the part as the row holds it, or undefined
 * when the tool renders as the plain name row.
 *
 * The registry types each component by its tool and the row holds any part; this is the one place
 * the two meet. The cast is safe on one fact, checked here rather than assumed: the part's type is
 * `tool-<name>`, so the part is the one the component under that name is typed for. A tool
 * resolved at run time carries its name in a field instead and is left to the name row, whatever
 * it is called.
 */
const readToolComponent = (part: IAiChatMessagePart, name: string): TToolComponent | undefined => {
  if (part.type !== `${TOOL_TYPE_PREFIX}${name}`) {
    return undefined;
  }

  return (TOOL_COMPONENTS as Record<string, TToolComponent | undefined>)[name];
};

export default readToolComponent;
